import React, { FC } from 'react';

import { Container } from './container';
import { Product } from './product';
import { ProductControl } from './styled';
import { IProductDetailListItemProps } from './types';

export const ProductDetailListItem: FC<React.PropsWithChildren<IProductDetailListItemProps>> = ({
  controls,
  isClickable,
  onProductClick,
  onNavigate,
  productProps,
  accessibilityRole,
  accessibilityLabel,
  accessibilitySelected,
  accessibilityChecked,
}) => {
  return (
    <Container
      isClickable={isClickable}
      onNavigate={onNavigate}
      onProductClick={onProductClick}
      accessibilityRole={accessibilityRole}
      accessibilityLabel={accessibilityLabel}
      accessibilitySelected={accessibilitySelected}
      accessibilityChecked={accessibilityChecked}
    >
      <Product {...productProps} />
      {controls && <ProductControl>{controls}</ProductControl>}
    </Container>
  );
};
